import { render, staticRenderFns } from "./BounceList.vue?vue&type=template&id=6f8fb156&scoped=true"
import script from "./BounceList.vue?vue&type=script&lang=js"
export * from "./BounceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8fb156",
  null
  
)

export default component.exports